const hash = {"en":"05fa56a93d4337231a5033c97d2ae64f","ru":"1d35a8b5230764c6b7775ed5aecba7a2","sv":"9cb8aab7cb19e00bf24ba40432d96d69"}
export default hash